<section class="bg-white dark:bg-gray-900">
  <div class="max-w-screen-xl px-1 py-8 mx-auto w-full lg:py-24 lg:px-6">

    <div class="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
      <h2 class="mb-4 text-2xl sm:text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
        Formations
      </h2>
      <p class="mb-5 font-bold text-gray-500 sm:text-xl dark:text-gray-400">
        Retrouvez ici les formations disponibles.
      </p>
    </div>
    @if (loading()) {
    <div class="text-center text-gray-500 dark:text-gray-300 font-semibold">
      Chargement...
    </div>
    } @else {

    @if (formations().length == 0) {
    <div class="text-center text-red-500 font-semibold">
      Aucune formation disponible
    </div>
    }@else {
    <div class="card">
      <p-dataview #dv [value]="formations()" [layout]="layout">
        <ng-template #header>
          <div class="flex justify-end">
            <p-selectbutton [(ngModel)]="layout" [options]="options" [allowEmpty]="false">
              <ng-template #item let-item>
                <i class="pi " [ngClass]="{ 'pi-bars': item === 'list', 'pi-table': item === 'grid' }"></i>
              </ng-template>
            </p-selectbutton>
          </div>
        </ng-template>
        <ng-template #list let-items>
          <div *ngFor="let item of items; let first = first">
            <div class="flex flex-col sm:flex-row sm:items-center p-6 gap-4"
              [ngClass]="{ 'border-t border-surface-200 dark:border-surface-700': !first }">
              <div class="md:w-40 relative">
                <img class="block xl:block mx-auto rounded w-full" [src]="item.cover_image_path"
                  alt="image de la formation" />

              </div>
              <div class="flex flex-col md:flex-row justify-between md:items-center flex-1 gap-6">
                <div class="flex flex-row md:flex-col justify-between items-start gap-2">
                  <div>
                    <span class="font-medium text-surface-500 dark:text-surface-400 text-sm">{{ item.title }}</span>
                    <div class="text-lg font-medium mt-2 whitespace-pre-line">{{ item.description }}</div>
                  </div>

                </div>
                <div class="flex flex-col md:items-end gap-8">
                  <span class="text-xl font-semibold">{{ item.price_eur | currency: 'EUR' }}</span>
                  <div class="flex flex-row-reverse md:flex-row gap-2">
                    @if (item.is_purchased) {
                    <button pButton icon="pi pi-download" class="p-button-text p-button-plain hover:bg-gray-100"
                      (click)="downloadFormation(item)" aria-label="Télécharger la formation">
                    </button>
                    } @else {
                    <button pButton icon="pi pi-shopping-cart" label="Acheter la formation"
                      class="flex-auto md:flex-initial whitespace-nowrap" (click)="purchase_formation(item)">
                    </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #grid let-items>
          <div class="grid grid-cols-12 gap-4">
            <div *ngFor="let formation of items" class="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-6 p-2">
              <div
                class="p-6 border border-surface-200 dark:border-surface-700 bg-surface-0 dark:bg-surface-900 rounded flex flex-col">
                <div class="bg-surface-50 flex justify-center rounded p-2">
                  <div class="relative mx-auto w-full">
                    <img class="rounded w-full" [src]="formation.cover_image_path" alt="image de la formation" />
                  </div>
                </div>
                <div class="pt-6">
                  <div class="flex flex-row justify-between products-start gap-2">
                    <div>
                      <span class="font-medium text-surface-500 dark:text-surface-400 text-sm">{{
                        formation.title
                        }}</span>
                      <div class="text-lg font-medium mt-1 whitespace-pre-line">{{ formation.description }}</div>
                    </div>

                  </div>
                  <div class="flex flex-col gap-6 mt-6">
                    <span class="text-2xl font-semibold">{{ formation.price_eur | currency: 'EUR' }}</span>
                    <div class="flex gap-2">
                      @if(formation.is_purchased){
                      <button pButton icon="pi pi-download" class="p-button-text p-button-plain hover:bg-gray-100"
                        (click)="downloadFormation(formation)" aria-label="Télécharger la formation">
                      </button>
                      }@else {
                      <button pButton icon="pi pi-shopping-cart" label="Acheter la formation"
                        class="flex-auto whitespace-nowrap" (click)="purchase_formation(formation)"></button>
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-dataview>
    </div>
    }
    }

  </div>
</section>